import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { Observable } from "rxjs";
@Injectable()
export class DemandService {
  private base_url = `${environment.API_URL}/demands`;
  private single_url = `${environment.API_URL}/demand`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getDemands(params) {
    params["token"] = this.token;
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createDemand(params) {
    params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Demande Ajoutée avec succès.", false, "Demande");
        } else {
          //console.log(response);
          this.toast.error(
            "Erreur lors de l'ajout de la Demande.",
            false,
            "Demande"
          );
        }
      });
  }

  updateDemand(demand_id: number, params: object) {
    //params["token"] = this.token;
    return this.http
      .patch(`${this.single_url}/${demand_id}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        //console.log(response);
        if (response === 200) {
          this.toast.success("Demande Mise à jour.", false, "Demande");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de la Demande",
            false,
            "Demande"
          );
        }
      });
  }

  deleteDemand(demand_id) {
    return this.http
      .delete(`${this.single_url}/${demand_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Demande Supprimée.", false, "Demande");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de la demande.",
            false,
            "Demande"
          );
        }
      });
  }
  getHistory(demand_id)
  {
    let params = { token: this.token, demand_id: demand_id };
    return this.http
      .post(`${environment.API_URL}/demands/history`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
  getMatchingOffers(demand_id) {
    let params = { token: this.token, demand_id: demand_id };
    return this.http
      .post(`${environment.API_URL}/offers/match`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getPinnedOffers(demand_id) {
    let params = { token: this.token };
    return this.http
      .post(
        `${environment.API_URL}/demand/${demand_id}/pinned_offers`,
        params,
        { headers: this.headers }
      )
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  pinUnpinOffer(params) {
    //params["token"] = this.token;
    return this.http
      .post(`${environment.API_URL}/demand/pin_unpin`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  sendPinnedOffers(demand_id) {
    let params = { token: this.token };
    return this.http
      .post(`${environment.API_URL}/demand/${demand_id}/send_offers`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Email Envoyés au transporteurs", false, "Mail");
        }
      });
  }

  sendSelectedDemandsToSelectedTransporters(demands: number[], offers: number[], favoriteTransporters: number[], planningTransporters: number[]) {

    const body = { token: this.token, demands: demands , offers: offers, favoriteTransporters: favoriteTransporters, planningTransporters: planningTransporters};
    return this.http.post(`${environment.API_URL}/demands/send_selected`, body, {
      headers: this.headers
    }).map((res) =>  JSON.parse(JSON.stringify(res)))
  }

  getPlannedDemands(departure_id: number, arrival_id: number): Observable<any> {
    const body = { departure_id, arrival_id, token: this.token };
    
    return this.http.post(`${environment.API_URL}/plannings/history`, body, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }
//get favorite transporters
  getFavoriteTransporters(): Observable<any> {
    const body = { token: this.token };
    return this.http.post(`${environment.API_URL}/transporteurs/favorite`, body, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));

  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/demand.service.ts